import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Gamepad2 } from 'lucide-react';
import { AppBadge } from './ui';
import { motion, AnimatePresence } from 'framer-motion';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Handle hash scrolling
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }, 100);
      }
    } else if (location.pathname === '/') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Features',
    path: '/#features'
  }, {
    name: 'Marketplace',
    path: '/#marketplace'
  }, {
    name: 'Rewards',
    path: '/#rewards'
  }, {
    name: 'FAQ',
    path: '/faq'
  }, {
    name: 'Support',
    path: '/support'
  }, {
    name: 'Legal',
    path: '/terms'
  }];
  return <header className={`fixed top-[40px] sm:top-[36px] w-full z-40 transition-all duration-300 ${isScrolled ? 'bg-[#050810]/80 backdrop-blur-xl border-b border-white/10 py-3' : 'bg-transparent py-5'}`} data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-117">
        {/* Logo */}
        <Link to="/" className="flex items-center group" data-id="element-118">
          <span className="text-2xl font-extrabold tracking-tight text-white" data-id="element-119">
            KDX
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-120">
          {navLinks.map(link => <Link key={link.name} to={link.path} className="text-sm font-medium text-gray-300 hover:text-white hover:text-glow transition-all" data-id="element-121">
              {link.name}
            </Link>)}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden lg:flex items-center gap-3" data-id="element-122">
          <AppBadge platform="ios" className="scale-75 origin-right" data-id="element-123" />
          <AppBadge platform="android" className="scale-75 origin-left" data-id="element-124" />
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-gray-300 hover:text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-125">
          {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-126" /> : <Menu className="w-6 h-6" data-id="element-127" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-128">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 w-full bg-[#0a0e27]/95 backdrop-blur-xl border-b border-white/10 lg:hidden" data-id="element-129">
            <div className="px-4 py-6 flex flex-col gap-4" data-id="element-130">
              {navLinks.map(link => <Link key={link.name} to={link.path} onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-gray-300 hover:text-white block py-2 border-b border-white/5" data-id="element-131">
                  {link.name}
                </Link>)}
              <div className="flex flex-col gap-3 mt-4" data-id="element-132">
                <AppBadge platform="ios" className="w-full justify-center" data-id="element-133" />
                <AppBadge platform="android" className="w-full justify-center" data-id="element-134" />
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
};